module.exports = __webpack_public_path__ + "img/discount-bg.c9107ec1.svg";